import { View, StyleSheet, TouchableOpacity } from "react-native";
import React from "react";
import Text from "@components/CustomText";
import color from "@constants/color";
import { useNavigation } from "@react-navigation/native";
import ChevronRight from "@assets/svg/ChevronRight";

const ListTile = ({ item }) => {
  const navigation = useNavigation();
  const subTitle = ({ subtitle, value }) => {
    return (
      <View style={styles.captionValueContainer}>
        <Text variant="caption_2" style={styles.subtitle}>
          {subtitle}
        </Text>
        <Text variant="caption_2" style={styles.value}>
          {value || "--"}
        </Text>
      </View>
    );
  };

  return item?.show_card === false ? null : (
    <TouchableOpacity
      testID="Dbm-list-tile"
      style={styles.container}
      activeOpacity={0.8}
      disabled={item?.nav_to === ""}
      onPress={() => {
        if (item?.nav_to) {
          navigation.navigate(item?.nav_to, {
            nav_params: item?.nav_params_data,
          });
        }
      }}
    >
      <View style={styles.headerContent}>
        <View>
          <Text
            variant="title_16"
            style={{ color: color.mediumBlack, marginBottom: 6 }}
          >
            {item?.title}
          </Text>
          {item?.subtitle_1
            ? subTitle({
                subtitle: item?.subtitle_1,
                value: item?.subtitle_1_value,
              })
            : null}
        </View>
      </View>
      <View style={styles.chevronContainer}>
        <ChevronRight
          pathFill={color.lightMediumBlack}
          style={styles.chevronIcon}
        />
      </View>
    </TouchableOpacity>
  );
};

export default ListTile;

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 12,
    borderRadius: 16,
    borderColor: color.lighterBlack,
    borderWidth: 0.5,
    margin: 16,
    marginVertical: 8,
    backgroundColor: color.white,
    minHeight: 64,
    elevation: 1,
    alignItems: "center",
  },
  captionValueContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  subtitle: {
    color: color.black06,
    marginRight: 2,
    lineHeight: 18,
  },
  value: {
    color: color.mediumBlack,
    fontWeight: "bold",
  },
  headerContent: {
    flexDirection: "row",
  },
  chevronContainer: {
    backgroundColor: color.lightGrayWhite,
    padding: 3,
    borderRadius: 4,
  },
  chevronIcon: {
    height: 16,
    width: 16,
  },
});
